export type DomainEventNames = 'created' | 'updated' | 'deleted';

export function createDomainEvents<TDomain extends string>(domain: TDomain) {
  const prefix = domain.toLowerCase();

  return {
    type: {
      created: `${prefix}-created` as const,
      updated: `${prefix}-updated` as const,
      deleted: `${prefix}-deleted` as const,
    } as const,

    idEvent: {
      created: (id: number) => `${prefix}-created-${id}` as const,
      updated: (id: number) => `${prefix}-updated-${id}` as const,
      deleted: (id: number) => `${prefix}-deleted-${id}` as const,
    },

    pattern: {
      created: new RegExp(`^${prefix}-created-(\\d+)$`),
      updated: new RegExp(`^${prefix}-updated-(\\d+)$`),
      deleted: new RegExp(`^${prefix}-deleted-(\\d+)$`),
    },

    extractId: (type: string): number | null => {
      const match = type.match(/-(\d+)$/);
      return match ? Number(match[1]) : null;
    },

    ofId: (id: number) =>
      ({
        updated: `${prefix}-updated-${id}` as const,
        deleted: `${prefix}-deleted-${id}` as const,
        created: `${prefix}-created-${id}` as const,
      }) as const,
  } as const;
}
